const { Utils } = require("@/assets/js/scripts/utils/Utils");
export class PiwikUtils {
	/**
	 *  Invia all'istanza di piwik (se presente) l'evento desiderato
	 */
	static inviaStatistica = function(categoria, action, object) {
		if(!Utils.isNullOrUndefined(window._paq)) {
			window._paq.push(['trackEvent', categoria, action, object]);
		}
	}

}